import { gql } from '@apollo/client'

export const TIMELINE_FRAGMENT = gql`
  fragment TimelineFragment on Timeline {
    id
    name
    startDate
    user {
      id
      firstName
      lastName
    }
    company {
      id
      name
    }
    site {
      id
      name
    }
    isPublished
    updatedAt
    createdAt
  }
`

const SITE_FIELDS = gql`
  fragment SiteFields on PreQualifiedSite {
    id
    name
  }
`

const COMPANY_FIELDS = gql`
  fragment CompanyFields on Company {
    id
    name
  }
`

export const TIMELINE_BASE_QUERIES = gql`
  ${SITE_FIELDS}
  ${COMPANY_FIELDS}
  query TIMELINE_BASE_QUERIES($siteFilter: JSON!, $companyFilter: JSON!) {
    sites: findSitesAdmin(filter: $siteFilter) {
      ...SiteFields
    }
    companies: findCompanies(filter: $companyFilter) {
      ...CompanyFields
    }
  }
`
